// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2wSSy","bigColWidth":"Table_bigColWidth__2MVw7","biggerColWidth":"Table_biggerColWidth__W7NMV","row":"Table_row__Kqi0g","col":"Table_col__2lWx-"};